import React from "react";

import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

/**
 * ExpandCardModal Component
 * 
 * Full-screen/large modal for displaying expanded detail view of a datatable record or card.
 * Shows comprehensive information within a modal dialog that takes up most of the viewport.
 * Controlled by parent component with show/hide flags and callback handlers. Responsive
 * with full-screen behavior on small devices. Includes close button and detailed content.
 * 
 * @param {Object} props - Component props containing modal state and handlers
 * @param {Object} props.expandData - Record/card data to display in expanded view
 * @param {boolean} props.showExpandCard - Flag controlling modal visibility
 * @param {Function} props.closeExpandCard - Callback to dismiss modal
 * @returns {JSX.Element} Modal dialog with expanded data details and link navigation
 */
const ExpandCardModal = ({ props }) => {
  const { expandData, showExpandCard, closeExpandCard } = props;

  return (
    <Modal
      className="modal-div"
      show={showExpandCard}
      onHide={closeExpandCard}
      fullscreen="sm-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton style={{ borderBottom: "none" }} />
      <Modal.Body>
        <div
          style={{
            border: "1px solid #dee2e6",
            borderRadius: "0.35rem",
            height: "80vh",
            overflow: "auto",
          }}
        >
          {Array.isArray(expandData) ? (
            <ol
              style={{
                paddingTop: "1.5em",
                paddingRight: "1.5em",
                paddingBottom: "1.5em",
                margin: "0 !important",
              }}
            >
              {expandData.map((element, index) =>
                !element ? (
                  ""
                ) : element.label ? (
                  <li key={index}>
                    {element.label}
                    {!element.reason ? "" : ": " + element.reason}
                  </li>
                ) : element.name ? (
                  <li key={index}>
                    {!element.slug ? (
                      element.name
                    ) : (
                      <Link
                        to={`/company/${element.slug}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="shutdowndatalink"
                      >
                        {element.name}
                      </Link>
                    )}
                    :{" "}
                    {!element.description
                      ? "No data available at this time."
                      : element.description}
                  </li>
                ) : (
                  ""
                )
              )}
            </ol>
          ) : (
            <p style={{ padding: "1.5em", margin: "0 !important" }}>
              {expandData}
            </p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExpandCardModal;
